// src/components/Button.js
import React from 'react';

const defaultStyle = {

  border: 'none',
  borderRadius: '4px',
  padding: '10px 20px',
  cursor: 'pointer',
  fontSize: '1rem'
};

const Button = ({ onClick, children, type = 'button', style = {} }) => {
  return (
    <button onClick={onClick} type={type} style={{ ...defaultStyle, ...style }}>
      {children}
    </button>
  );
};

export default Button;